import { useCallback } from 'react';
import api from '../../../../api/api';
import { INITIAL_SEARCH_PARAMS } from '../constants/invoiceManagementConstants';

export const useInvoiceManagementHandlers = (
    t,
    selectedItems,
    setAlertInfo,
    setStatusUpdateDialogOpen,
    setSelectedItems,
    fetchInvoiceData,
    setSearchParams,
    setPage,
    setInvoiceData,
    setTotalCount,
    setHasSearched,
    searchParams,
    isLoading
) => {

    const handleSearch = useCallback(() => {
        if (!searchParams.startDate) {
            setAlertInfo({
                open: true,
                title: t('error.title'),
                message: t('invoice.error.startDateRequired'),
                severity: 'warning'
            });
            return;
        }
        setHasSearched(true);
    }, [searchParams.startDate, setAlertInfo, t, setHasSearched]);

    const handleReset = useCallback(() => {
        setSearchParams(INITIAL_SEARCH_PARAMS);
        setPage(0);
        setInvoiceData([]);
        setTotalCount(0);
        setSelectedItems([]);
        setHasSearched(false);
    }, [setSearchParams, setPage, setInvoiceData, setTotalCount, setSelectedItems, setHasSearched]);

    const handleStatusUpdate = useCallback(() => {
        if (selectedItems.length === 0) {
            setAlertInfo({
                open: true,
                title: t('error.title'),
                message: t('invoice.error.selectItemsForStatusUpdate'),
                severity: 'warning'
            });
            return;
        }
        setStatusUpdateDialogOpen(true);
    }, [selectedItems.length, setAlertInfo, t, setStatusUpdateDialogOpen]);

    const handleStatusUpdateConfirm = useCallback(async (newStatus) => {
        try {
            const updatePromises = selectedItems.map(invoiceId =>
                api.patch(`/invoice/v1/invoice/item/${invoiceId}/status?status=${newStatus}`)
            );

            const results = await Promise.all(updatePromises);
            const successCount = results.filter(result => result.status === 200).length;
            const failCount = results.length - successCount;

            if (successCount > 0) {
                setAlertInfo({
                    open: true,
                    title: t('success.title'),
                    message: t('invoice.success.statusUpdate', { 
                        success: successCount, 
                        fail: failCount 
                    }),
                    severity: 'success'
                });

                setHasSearched(true);
                setSelectedItems([]);
                setStatusUpdateDialogOpen(false);
            } else {
                setAlertInfo({
                    open: true,
                    title: t('error.title'),
                    message: t('invoice.error.statusUpdateFailed'),
                    severity: 'error'
                });
            }
        } catch (error) {
            setAlertInfo({
                open: true,
                title: t('error.title'),
                message: t('invoice.error.statusUpdateFailed'),
                severity: 'error'
            });
        }
    }, [selectedItems, setAlertInfo, t, setHasSearched, setSelectedItems, setStatusUpdateDialogOpen]);

    return {
        handleSearch,
        handleReset,
        handleStatusUpdate,
        handleStatusUpdateConfirm
    };
}; 